import React, { useEffect } from "react";
import { connect } from "react-redux";

import PinLegendType from "@mapmycustomers/shared/enum/PinLegendType";
import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";
import PinLegend from "@mapmycustomers/shared/types/map/PinLegend";

import { hidePinLegendDrawer } from "@app/scene/map/store/actions";
import { pinLegendsState } from "@app/scene/map/store/selectors";
import { RootState } from "@app/store/rootReducer";
import loggingService from "@app/util/logging";

import CreateEditColorPinLegendDrawer from "./CreateEditColorPinLegendDrawer";
import CreateEditShapePinLegendDrawer from "./CreateEditShapePinLegendDrawer";

interface Props {
  entityType?: EntityTypesSupportedByMapsPage;
  onHide: () => void;
  pinLegend?: PinLegend;
  type?: PinLegendType;
}

const CreateEditPinLegendDrawer: React.FC<Props> = ({ entityType, onHide, pinLegend, type }) => {
  // explicitly call onHide when component is unmounted. E.g. when the entire map page closes
  useEffect(() => () => onHide(), [onHide]);

  if (!entityType || !type) {
    return null;
  }

  if (pinLegend?.type && pinLegend.type !== type) {
    loggingService.warning(`Tried to edit pin legend, but types don't match`, {
      pinLegendType: pinLegend?.type,
      type,
    });
  }

  const actualType = pinLegend?.type ?? type; // pinLegend's type takes precedence

  return actualType === PinLegendType.COLOR ? (
    <CreateEditColorPinLegendDrawer
      entityType={entityType}
      key={pinLegend?.id} // to force re-create when another pinLegend is about to be edited
      onHide={onHide}
      pinLegend={pinLegend}
    />
  ) : (
    <CreateEditShapePinLegendDrawer
      entityType={entityType}
      key={pinLegend?.id} // to force re-create when another pinLegend is about to be edited
      onHide={onHide}
      pinLegend={pinLegend}
    />
  );
};

const mapStateToProps = (state: RootState) => pinLegendsState(state);

const mapDispatchToProps = {
  onHide: hidePinLegendDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateEditPinLegendDrawer);
